module.exports = __webpack_public_path__ + "img/ring_skip_0_null_null@2x.3c16ecac.png";